angular
  .module('ATMGurus')
  .component('atmgNav', {
    bindings: {},
    scope: true,
    bindToController: {},
    controllerAs: 'MainCtrl',
    controller: makeControllerFn(),
    template: require('Templates/main/nav.html')
  })

  function makeControllerFn() {
    return class AtmgNav {

      constructor($scope, User, $rootScope, Cart, Navigation) {
        this.$scope = $scope
        this.User = User
        this.UserService = User
        this.$rootScope = $rootScope
        this.Cart = Cart
        this.Navigation = Navigation
        this.contactForm = {}
      }

      showContactForm (type) {
        var modalData = undefined;
        switch( type ) {
          case 'callback-form':
            modalData = {title: 'Request a callback', template: 'email_customer_service'}
            break;
          case 'email-form':
            modalData = {title: 'Email Us', template: 'email_customer_service'}
            break;
          default:
            break;
        }

        this.$scope.$emit("modal.open", modalData)

        // let userData = this.User.getUserData()

        // this.contactForm = {
        //   dept: 'customer.service@atmgurus.com',
        //   email: userData.userDetails.email || undefined,
        //   name: userData.userDetails.first_name  || undefined
        // }
      }

      // submit(type) {
      //   this.$scope.$emit("modal.open", {})
      //   this.FormService.post(type, this.contactForm)
      //     .then(response => {
      //       this.$scope.$emit("modal.close", {} )
      //       if (response) {
      //         this.$scope.$emit("modal.open", { title: "Contact request", template: 'success', data: { message: response.message} } )
      //       }
      //       else {
      //         $scope.$emit("modal.open", { title: "Contact request", template: 'error', data: { message: reason.message } } )
      //       }
      //     })
      //     .catch(reason => {
      //       $scope.$emit("modal.open", { title: "Contact request", template: 'error', data: { message: reason.message } } )
      //     })
      // }

      isLogged() {
        return this.$rootScope.isLogged
      }

    }
  }


// WEBPACK FOOTER //
// ./src/app/components/atmgNav.js